<script setup>
import { ref, watch, onMounted } from 'vue';
import { useCifraClient } from '@/api/cifra-client';

const props = defineProps({
  grupos: { type: Array, default: () => [] },
  grupoInicial: { type: [Number, String], default: null },
  alumnoInicial: { type: [Number, String], default: null },
  asignaturaInicial: { type: [Number, String], default: null },
  labelGrupo: { type: String, default: 'Grupo' },
  labelAlumno: { type: String, default: 'Alumno' },
  labelAsignatura: { type: String, default: 'Asignatura' },
  marcador: { type: String, default: 'Todos' },
});

const { cifraClient } = useCifraClient();

const grupoSeleccionado = ref(null);
const alumnoSeleccionado = ref(null);
const asignaturaSeleccionado = ref(null);
const alumnos = ref([]);
const asignaturas = ref([]);
const cargando = ref(false);

function normalizarOpciones(items) {
  return (items || []).map((item) => ({ id: item[1], label: item[0] }));
}

async function cargarAlumnosAsignaturas(grupoId) {
  cargando.value = true;
  try {
    const [alumnosRes, asignaturasRes] = await Promise.all([
      cifraClient.get('/gestion_grupos/find_alumnos_grupo', {
        params: { grupo_id: grupoId },
      }),
      cifraClient.get('/gestion_grupos/find_asignaturas_grupo', {
        params: { grupo_id: grupoId },
      }),
    ]);
    alumnos.value = normalizarOpciones(alumnosRes.data.alumnos);
    asignaturas.value = normalizarOpciones(asignaturasRes.data.asignaturas);
  } catch {
    alumnos.value = [];
    asignaturas.value = [];
  } finally {
    cargando.value = false;
  }
}

watch(grupoSeleccionado, (nuevo) => {
  alumnoSeleccionado.value = null;
  asignaturaSeleccionado.value = null;
  if (nuevo?.id) {
    cargarAlumnosAsignaturas(nuevo.id);
  } else {
    alumnos.value = [];
    asignaturas.value = [];
  }
});

onMounted(async () => {
  if (props.grupoInicial) {
    const g = props.grupos.find((gr) => gr.id === Number(props.grupoInicial));
    if (g) {
      grupoSeleccionado.value = g;
      await cargarAlumnosAsignaturas(g.id);
      if (props.alumnoInicial) {
        const a = alumnos.value.find(
          (al) => al.id === Number(props.alumnoInicial),
        );
        if (a) alumnoSeleccionado.value = a;
      }
      if (props.asignaturaInicial) {
        const a = asignaturas.value.find(
          (as) => as.id === Number(props.asignaturaInicial),
        );
        if (a) asignaturaSeleccionado.value = a;
      }
    }
  }
});
</script>

<template>
  <div class="col-xs-3 m-b-xs">
    <label class="font-normal control-label">{{ labelGrupo }}</label>
    <select-cifra
      v-model="grupoSeleccionado"
      :opciones="grupos"
      campo-etiqueta="label"
      campo-id="id"
      :marcador="marcador"
      nombre-input="filtro_informe_justificaciones_grupo[grupo]"
    />
  </div>
  <div class="col-xs-3 m-b-xs">
    <label class="font-normal control-label">{{ labelAlumno }}</label>
    <select-cifra
      v-model="alumnoSeleccionado"
      :opciones="alumnos"
      campo-etiqueta="label"
      campo-id="id"
      :marcador="marcador"
      nombre-input="filtro_informe_justificaciones_grupo[alumno]"
    />
  </div>
  <div class="col-xs-3 m-b-xs">
    <label class="font-normal control-label">{{ labelAsignatura }}</label>
    <select-cifra
      v-model="asignaturaSeleccionado"
      :opciones="asignaturas"
      campo-etiqueta="label"
      campo-id="id"
      :marcador="marcador"
      nombre-input="filtro_informe_justificaciones_grupo[asignatura]"
    />
  </div>
</template>
